import { faNetworkWired, faServer, faFolderOpen, faLock, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { ConnectionTypeEnum } from "../types/outputDestinationsTypes";

export const getConnectionTypeIconAndLabel = ( connectionType: ConnectionTypeEnum): { icon: any; label: string } => {
  switch (connectionType) {
    case ConnectionTypeEnum.NETWORK:
      return { icon: faNetworkWired, label: "Network" };
    case ConnectionTypeEnum.FTP:
      return { icon: faServer, label: "FTP" };
    case ConnectionTypeEnum.LOCAL_DIRECTORY:
      return { icon: faFolderOpen, label: "Local" };
    case ConnectionTypeEnum.SFTP:
      return { icon: faLock, label: "SFTP" };
    default:
      return { icon: faQuestionCircle, label: "Unknown" };
  }
};
